/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React, {forwardRef} from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {Button} from '@chakra-ui/react'
import {LockIcon} from '../../../components/icons'
import Link from '../../../components/link'

const CartCta = forwardRef((_, ref) => {
    const {formatMessage} = useIntl()
    return (
        <Button
            ref={ref}
            as={Link}
            to="/appcheckout"
            rightIcon={
                <LockIcon
                    role="img"
                    aria-label={formatMessage({
                        defaultMessage: 'Secure Checkout',
                        id: 'global.secure_checkout'
                    })}
                    aria-hidden={false}
                />
            }
            iconSpacing={4}
            variant="placeOrder"
            padding={2.5}
            size="lg"
            data-testid="proceed-to-checkout-button"
        >
            <FormattedMessage defaultMessage="Proceed to Checkout" id="cart_cta.link.checkout" />
        </Button>
    )
})

CartCta.displayName = 'CartCta'

export default CartCta
